import styled from '@/styles';

const Pill = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 10px',
  borderRadius: '6px',
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  variants: {
    tone: {
      green: { backgroundColor: '#E7F4E6', color: '#17722F' },
      amber: { backgroundColor: '#FFF4D8', color: '#7A5600' },
      red: { backgroundColor: '#FFDFD8', color: '#B0030A' },
      grey: { backgroundColor: '#EDEDED', color: '#4A4A4A' },
      blue: { backgroundColor: '#E3EDFB', color: '#1A4C93' },
    },
  },
});

export default Pill;
